import { LegalLayout } from "./components/legalLayout";
import { PRIVACY_POLICY } from "./content/privacyPolicy";

/** /politica-de-privacidade — também servida em /privacy-policy, com canonical aqui. */
export const PoliticaDePrivacidade = () => (
  <LegalLayout document={PRIVACY_POLICY} />
);
